var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loyal_customer_l6uz5ur80b5l 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M13.0501 4.88841C13.3516 3.97164 14.6484 3.97164 14.9499 4.88841L16.8121 10.5504C16.9113 10.8521 17.1479 11.0887 17.4496 11.1879L23.1116 13.0501C24.0284 13.3516 24.0284 14.6484 23.1116 14.9499L17.4496 16.8121C17.1479 16.9113 16.9113 17.1479 16.8121 17.4496L14.9499 23.1116C14.6484 24.0284 13.3516 24.0284 13.0501 23.1116L11.1879 17.4496C11.0887 17.1479 10.8521 16.9113 10.5504 16.8121L4.88841 14.9499C3.97164 14.6484 3.97164 13.3516 4.88841 13.0501L10.5504 11.1879C10.8521 11.0887 11.0887 10.8521 11.1879 10.5504L13.0501 4.88841Z",
    stroke: "url(#paint0_linear_0_414)",
    strokeWidth: 2.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_414",
    x1: 4,
    y1: 24,
    x2: 24,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e4e168946d3e3a78143b4160144e801b.svg";
export { ForwardRef as ReactComponent };